import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './components/assets/css/custom.css';
import './components/assets/css/plugin.css';
import './components/assets/css/theme.css';
import Bank from './components/pages/Bank';
import Commission from './components/pages/Commission';
import Hierarchy from './components/pages/Hierarchy';
import Home from './components/pages/Home';
import KYC from './components/pages/KYC';
import Login from './components/pages/login';
import Material from './components/pages/Material';
import Member from './components/pages/Member';
import Performance from './components/pages/Performance';
import Profile from './components/pages/Profile';
import Registration from './components/pages/Registration';
import StoreCode from './StoreCodeComponents';
import SweetAlert2 from 'react-sweetalert2';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
 
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [showSplash, setShowSplash] = useState(true); 
	const [logo, setLogo] = useState([]);
	const [swalProps, setSwalProps] = useState({});

  // Function to dynamically set the favicon
  const setFavicon = (url) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = url;
      document.head.appendChild(newLink);
    } else {
      link.href = url;
    }
  };
  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/balance`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
  
        if (response.ok) {
          const data = await response.json();
          localStorage.setItem('balance', data.balance);
        } else if (response.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    } else {
      console.warn('No token found in local storage.');
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = '/login';
  };
  useEffect(() => {
    if (isLoggedIn) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 10000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, fetchBalance]);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) {
          throw new Error("Failed to fetch promotions");
        }
        const data = await response.json();
        setLogo(data[0].logo);
        setFavicon(`${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`); // Set the favicon
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);
  
  

  useEffect(() => {
    // Hide the splash screen after 3 seconds
    const splashTimeout = setTimeout(() => setShowSplash(false), 1000);
    return () => clearTimeout(splashTimeout);
  }, []);
  

  return (
    <Router>
      <div className="App">
	  		<SweetAlert2 {...swalProps} />
          <Routes>
            <Route path="/login" element={<Login setSwalProps={setSwalProps} />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/bank"
              element={
                <PrivateRoute>
                  <Bank />
                </PrivateRoute>
              }
            />
            <Route
              path="/kyc"
              element={
                <PrivateRoute>
                  <KYC />
                </PrivateRoute>
              }
            />
            <Route
              path="/member"
              element={
                <PrivateRoute>
                  <Member />
                </PrivateRoute>
              }
            />
            <Route
              path="/registration"
              element={
                <PrivateRoute>
                  <Registration />
                </PrivateRoute>
              }
            />
            <Route
              path="/performance"
              element={
                <PrivateRoute>
                  <Performance />
                </PrivateRoute>
              }
            />
            <Route
              path="/commission"
              element={
                <PrivateRoute>
                  <Commission />
                </PrivateRoute>
              }
            />
            <Route
              path="/material"
              element={
                <PrivateRoute>
                  <Material />
                </PrivateRoute>
              }
            />
            <Route
              path="/hierarchy"
              element={
                <PrivateRoute>
                  <Hierarchy />
                </PrivateRoute>
              }
            />
            <Route path="/referral_code" element={<StoreCode codeType="referral_code" />} />
            <Route path="/affiliate_code" element={<StoreCode codeType="affiliate_code" />} />
          </Routes>
      
      </div>
    </Router>
  );
}

export default App;
